export const HOME_RETENTION_ACTION = "RETENCION_RESIDENCIAL";

export const SCORING_ACTIONS = {
  NUEVO_SERVICIO: {
    id: "NUEVO_SERVICIO",
    name: "Nuevo Servicio"
  },
  RETENCION_RESIDENCIAL: {
    id: "RETENCION_RESIDENCIAL",
    name: "Dar de Baja"
  },
  AFILIAR_DEBITO_AUTOMATICO: {
    id: "AFILIAR_DEBITO_AUTOMATICO",
    name: "Afiliar a débito automático"
  }
};

export const SCORING_FLOW_TYPES = {
  EDIT: "EDIT",
  EDIT_DEVICES: "EDIT_DEVICES",
  NEW: "NEW",
  EXISTING: "EXISTING" 
};

export const SCORING_LOOK_TYPES = {
  HOME: "HOME",
  ALL: "ALL",
  RETENTION_OFFERS: "RETENTION_OFFERS",
  FIBERTEC: "FIBERTEC"
};

export const SCORING_ROUTE_NAMES_BASE = {
  MAIN: 'scoring-main',
  OFFERS: 'scoring-offers',
  CART: 'scoring-cart',
  CART_SUMMARY: 'scoring-cart-summary',
  HOME_RETENTION: 'retention-flow',
  TELEMARKETING_RAC_CAMPAIGNS: 'telemarketing-rac-campaigns',
  TELEMARKETING_RAC_CLIENTS: 'telemarketing-rac-clients',
};

export const SCORING_CONFIGS = {
  PROD: '5d1ff36177a22c21794ed5c4',
  DEV: '5d0974a97a2531f769a06101',
  TEST: '5d94d822d77eb726d20434ad',
  ACTIVATIONS: '5df10911d77eb726d223921d'
};

export const SCORING_OFFER_FLOW_TYPES = {
  DEVICE: 'DEVICE',
  BYOD: 'BYOD',
  HOME: 'HOME',
  HOME_RETENTION: 'HOME_RETENTION',
  PAYMENT_GATEWAY_POLL: 'PAYMENT_GATEWAY_POLL',
  PLAIN_MAP: 'PLAIN_MAP'
};

export const SCORING_OFFER_FROM_TYPE = {
  ACTION: 'ACTION',
  NOT_ACTION: 'NOT_ACTION'
};

export const TELEMARKETING = {
  STATUS: {
    COMPLETED: 'COMPLETED',
    SCHEDULED: 'SCHEDULED',
    PENDING: 'PENDING',
  },
  FIELDS: {
    LIST: 'list',
    OFFER: 'offer',
    TEXT: 'text',
    DATE: 'date',
  },
};

export const CART_FLOW = {
  FULL: 'FULL',
  NO_REDIRECT: 'NO_REDIRECT',
};

export const OFFER_STATUS = {
  PENDING: "PENDING",
  COMPLETED: "COMPLETED"
}
export const TOKEN_NAME = "horus_token";
